import isEmpty from 'lodash/isEmpty'
import React from 'react'

import type { InlineInputProps } from '@ztechapps/webui.input'
import { InlineInput } from '@ztechapps/webui.input'
import { AddressInput } from './AddressInput'
import { SaveCancelButtons } from '@ztechapps/webui.button'
import { Stack } from 'react-bootstrap'

type AddressInlineProps = {
  includeGps?: boolean
}
export type AddressInlineInputProps = InlineInputProps<AddressInlineProps>

export const AddressInlineInput = ({
  parentInputComponent,
  initialValues,
  updateParams,
  displayContent,
  name = 'address',
  inputProps,
  ...rest
}: AddressInlineInputProps) => {
  const ParentInput = parentInputComponent || InlineInput

  //show the address.summary as the display
  displayContent = displayContent || ((a) => a?.fullAddress)

  const defaultUpdateParams = ({ _id, updatedValue }) => {
    const input = {
      _id,
      'contact.address1.street1': updatedValue?.street1,
      'contact.address1.street2': updatedValue?.street2,
      'contact.address1.street3': updatedValue?.street3,
      'contact.address1.city': updatedValue?.city,
      'contact.address1.state': updatedValue?.state?.value ?? updatedValue?.state,
      'contact.address1.zip': updatedValue?.zip,
      'contact.address1.fullAddress': updatedValue?.fullAddress,
      'contact.address1.country': updatedValue?.country?.value ?? updatedValue?.country,
      //always set the gps to null so it will build a new one
      'contact.address1.gps': inputProps?.includeGps ? updatedValue?.gps : null,
    }

    return {
      input,
    }
  }

  return (
    <ParentInput
      {...{
        ...rest,
        name,
        initialValues,
        displayContent,
        updateParams: updateParams ?? defaultUpdateParams,
        editContent: ({ saveNow, setNewValue, cancelNow, submitting, value }) => {
          return (
            <Stack gap={2}>
              <div>
                <AddressInput
                  {...{
                    value,
                    submitting,
                    onChange: setNewValue,
                    ...inputProps,
                  }}
                />
              </div>
              <div>
                <SaveCancelButtons
                  isBusy={submitting}
                  onSave={saveNow}
                  onCancel={cancelNow}
                  disabled={!isEmpty(value?.errors)}
                />
              </div>
            </Stack>
          )
        },
      }}
    />
  )
}
